<template>
  <div class="containerBox"  ref="box">
    <!--  顶部导航  -->
    <nav-bar />
    <!--  轮播图  -->
    <banner-list :banner-list="bannerList" />
    <!--  票据合规  -->
    <div class="piaoju">
      <div class="container1" v-scroll-reveal>
        <div class="piaoju_left">
          <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/echarts.png" alt="">
        </div>
        <div class="piaoju_right">
          <div class="piaoju_right_title">票据合规，物流互联网+时代</div>
          <div class="piaoju_right_border"></div>
          <p>中商情报网讯：2021年，我国运行稳中有进，社会物流总额保持良好增势，社会物流总费用与GDP的比率稳中有降，“十四五”实现良好开局。</p>
          <div class="piaoju_right_btn" @click="goDetail">查看详情 <span>→</span></div>
        </div>
      </div>
    </div>
    <!--  网络货运数据  -->
    <div class="numberData">
      <div class="container">
        <div class="title">网络货运高速发展，成为企业数字化转型的通道</div>
        <div class="title_border"></div>
        <div class="box">
          <div class="box_item">
            <div class="top"><span><countTo :startVal='0' :endVal='909680' :duration='3500'></countTo></span>吨</div>
            <div class="center">货源</div>
            <div class="bot"></div>
          </div>
          <div class="box_item">
            <div class="top"><span><countTo :startVal='0' :endVal='46795' :duration='3500'></countTo></span>+辆</div>
            <div class="center">车源</div>
            <div class="bot"></div>
          </div>
          <div class="box_item">
            <div class="top"><span><countTo :startVal='0' :endVal='63900' :duration='3500'></countTo></span>+万</div>
            <div class="center">货运总额</div>
            <div class="bot"></div>
          </div>
          <div class="box_item">
            <div class="top"><span><countTo :startVal='0' :endVal='6595' :duration='3500'></countTo></span>+万</div>
            <div class="center">后市场交易额</div>
            <div class="bot"></div>
          </div>
        </div>
      </div>
    </div>
    <!--  合作共赢 整合市场  -->
    <div class="cooperation container">
      <div class="title" v-scroll-reveal style="color: #333333">合作共赢 （整合市场 ）</div>
      <div class="title_border" v-scroll-reveal></div>
      <div class="cooperationBox" v-scroll-reveal>
        <div v-for="(item, index) in coopData" :key="index">
          <div v-if="coopIndex === index" class="coop_item1"  :key="index">
            <div class="pos"></div>
            <img :src="item.imgSrc" alt="">
            <div class="coop_item_box">
              <div class="coop_item_title over">{{ item.title }}</div>
              <p class="coop_item_content over5">{{ item.content }}</p>
            </div>
          </div>
          <div v-if="coopIndex !== index" class="coop_item"  :key="index" @mouseover="coopenter(index)">
            <img :src="item.imgSrc" alt="">
            <div class="coop_item_title over">{{ item.title }}</div>
            <p class="coop_item_content over5">{{ item.content }}</p>
          </div>
        </div>
      </div>
    </div>
    <!--  合作流程  -->
    <div id="process">
      <div class="container">
        <div class="title" v-scroll-reveal>合作流程</div>
        <div class="title_border" v-scroll-reveal></div>
        <div class="process_box" v-scroll-reveal>
          <div class="process_box_item" :style="processIndex === 0 ? 'background:#4E9BFF;': 'background: linear-gradient(180deg,#dcebff, #ffffff 100%)'" @mouseover="processover(0)" @mouseleave="processleave">
            <div class="pos_box">
              <img v-if="processIndex === 0" class="pos_line" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/dashed.png" alt="">
              <img v-else class="pos_line" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/dashed_a.png" alt="">
              <div class="pos_dotted" :style="processIndex === 0 ? 'background: rgba(78,155,255,0.50);' : 'background: rgba(255,255,255,0.30);'"><div></div></div>
            </div>
            <img v-if="processIndex === 0" class="logo" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/01_a.png" alt="" />
            <img v-else class="logo" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/01.png" alt="" />
            <p class="process_box_item_title" :style="processIndex === 0 ? 'color: #fff;' : 'color: #333333'">01</p>
            <img v-if="processIndex === 0" class="jiantou" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/Arrow14.png" alt="" />
            <img v-else class="jiantou" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/Arrow.png" alt="" />
            <p class="process_box_item_title" :style="processIndex === 0 ? 'color: #fff;' : 'color: #333333'">在线申请</p>
          </div>
          <div class="process_box_item" style="margin-top: 53px;" :style="processIndex === 1 ? 'background:#4E9BFF;': 'background: linear-gradient(180deg,#dcebff, #ffffff 100%)'" @mouseover="processover(1) " @mouseleave="processleave">
            <div class="pos_box">
              <img v-if="processIndex === 1" class="pos_line" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/dashed.png" alt="">
              <img v-else class="pos_line" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/dashed_a.png" alt="">
              <div class="pos_dotted" :style="processIndex === 1 ? 'background: rgba(78,155,255,0.50);' : 'background: rgba(255,255,255,0.30);'"><div></div></div>
            </div>
            <img class="arrowPos" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/Component.png" alt="" />
            <img v-if="processIndex === 1" class="logo" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/02_a.png" alt="" />
            <img v-else class="logo" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/02.png" alt="" />
            <p class="process_box_item_title" :style="processIndex === 1 ? 'color: #fff;' : 'color: #333333'">02</p>
            <img v-if="processIndex === 1" class="jiantou" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/Arrow14.png" alt="" />
            <img v-else class="jiantou" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/Arrow.png" alt="" />
            <p class="process_box_item_title" :style="processIndex === 1 ? 'color: #fff;' : 'color: #333333'">专业讲解</p>
          </div>
          <div class="process_box_item" style="margin-top: 53px;" :style="processIndex === 2 ? 'background:#4E9BFF;': 'background: linear-gradient(180deg,#dcebff, #ffffff 100%)'" @mouseover="processover(2)" @mouseleave="processleave">
            <div class="pos_box">
              <img v-if="processIndex === 2" class="pos_line" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/dashed.png" alt="">
              <img v-else class="pos_line" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/dashed_a.png" alt="">
              <div class="pos_dotted" :style="processIndex === 2 ? 'background: rgba(78,155,255,0.50);' : 'background: rgba(255,255,255,0.30);'"><div></div></div>
            </div>
            <img class="arrowPos" style="top: 142px;" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/Component.png" alt="" />
            <img v-if="processIndex === 2" class="logo" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/03_a.png" alt="" />
            <img v-else class="logo" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/03.png" alt="" />
            <p class="process_box_item_title" :style="processIndex === 2 ? 'color: #fff;' : 'color: #333333'">03</p>
            <img v-if="processIndex === 2" class="jiantou" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/Arrow14.png" alt="" />
            <img v-else class="jiantou" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/Arrow.png" alt="" />
            <p class="process_box_item_title" :style="processIndex === 2 ? 'color: #fff;' : 'color: #333333'">合作洽谈</p>
          </div>
          <div class="process_box_item" style="margin-right: 0;" :style="processIndex === 3 ? 'background:#4E9BFF;': 'background: linear-gradient(180deg,#dcebff, #ffffff 100%)'" @mouseover="processover(3)" @mouseleave="processleave">
            <div class="pos_box">
              <img v-if="processIndex === 3" class="pos_line" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/dashed.png" alt="">
              <img v-else class="pos_line" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/dashed_a.png" alt="">
              <div class="pos_dotted" :style="processIndex === 3 ? 'background: rgba(78,155,255,0.50);' : 'background: rgba(255,255,255,0.30);'"><div></div></div>
            </div>
            <img class="arrowPos" style="top: 152px;" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/Component.png" alt="" />
            <img v-if="processIndex === 3" class="logo" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/04_a.png" alt="" />
            <img v-else class="logo" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/04.png" alt="" />
            <p class="process_box_item_title" :style="processIndex === 3 ? 'color: #fff;' : 'color: #333333'">04</p>
            <img v-if="processIndex === 3" class="jiantou" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/Arrow14.png" alt="" />
            <img v-else class="jiantou" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/Arrow.png" alt="" />
            <p class="process_box_item_title" :style="processIndex === 3 ? 'color: #fff;' : 'color: #333333'">签订合同</p>
          </div>
        </div>
        <img class="posIcon" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/ellipse.png" alt="">
      </div>
    </div>
    <!--  申请表单  -->
    <div class="submit container">
      <div class="title" v-scroll-reveal style="color: #333333;">申请表单</div>
      <div class="title_border" v-scroll-reveal></div>
      <div class="submit_box" v-scroll-reveal>
        <div class="submit_box_left">
          <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/process/submit_bg.png" alt="">
        </div>
        <div class="submit_box_right">
          <div class="submit_box_right_title">手机号</div>
          <input type="text" v-model="formData.cusPhone" placeholder="请输入您的手机号">
          <div class="submit_box_right_title">微信号</div>
          <input type="text" v-model="formData.cusWechat" placeholder="请输入您的微信号">
          <div class="submit_box_right_title">邮箱</div>
          <input type="text" v-model="formData.cusEmail" placeholder="请输入您的邮箱">
          <div class="btn" @click="submit">提交</div>
        </div>
      </div>
    </div>
    <!--  底部  -->
    <bottom-footer/>
    <!--  悬浮按钮  -->
    <fix-anchor @goBottom="goBottom" :box="$refs['box']" />
   </div>
</template>

<script>
import NavBar from '@/components/nav-bar.vue'
import BannerList from '@/components/banner-list.vue'
import BottomFooter from '@/components/bottom-footer.vue'
import FixAnchor from '@/components/fix-anchor.vue'
import countTo from 'vue-count-to';
import { plus } from '@/common/encryption'
import 'swiper/dist/js/swiper'
import 'swiper/dist/css/swiper.css'
export default {
  name: "BusinessCooperation",
  components: {
    NavBar,
    BannerList,
    BottomFooter,
    FixAnchor,
    countTo,
  },
  data() {
    return{
      formData: {
        cusPhone: '',
        cusWechat: '',
        cusEmail: '',
      },
      bannerList: [{coverImgUrl:'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/banner/business_banner.png'}],
      processIndex: null,
      coopIndex: 0,
      coopData: [
        {
          title: '（1）票据合规、降低税负',
          content: '为货主企业开具合法合规增值税专用运输发票收取平台服务费用。 为个人货主代替司机开具普通运输发票收取平台服务费用',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/coop1.png'
        },
        {
          title: '（2）智能转型、降低陈本 提高营收',
          content: '1、网络货运平台可通过对接保险、ETC、加油站等三方团购来取得过路票和油票，为司机节省费用成本，留取一定返点，同时还可增加进项抵扣，降低开票成本。2、为企业提供智慧物流管理系统解决方案，为企业提供物流数字化、信息化、智能化转型升级服务，开发软件系统收取技术服务费。3、广告费。',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/coop2.png'
        },
        {
          title: '（3）强大的技术支持为大客户提供针对性的解决方案',
          content: '强大的技术支持为大客户提供针对性的解决方案\n' +
              '平台具有技术优势、运营优势、资质优势、政策优势、系统产品优势、品牌优势、数据优势、成本优势等核心竞争力。欢迎各位朋友一起加入合作，为企业提供智能物流解决方案服务，物流软件系统开发维护运营服务，资质牌照办理服务，政府奖励补贴政策申请服务。',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/coop3.png'
        }
      ]
    }
  },
  created() {
    // this.$public.getBanner(13, 0).then(res=>{
    //   this.bannerList = res.data.data.records
    // })
  },
  methods: {
    /**
     * @description: 合作流程划入
     * @author: 书童
    */
    submit() {
      // alert(this.formData.cusPhone+this.formData.cusWechat+this.formData.cusEmail)
      // 验证手机号
      let regExp = new RegExp("^1[23456789]\\d{9}$")
      if (!regExp.test(this.formData.cusPhone)) {
        alert('手机号格式错误！')
        return
      }
      // 验证微信号
      if (this.formData.cusWechat.length > 32) {
        alert('微信号格式错误！')
        return
      }
      let regExpMail = new RegExp("^[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,5}$")
      if (this.formData.cusEmail.length > 0 && !regExpMail.test(this.formData.cusEmail)) {
        alert('邮箱格式错误！')
        return
      }
      let data = plus(this.formData)
      data.time = Date.parse(new Date())
      console.log('加密', data);
      this.$axios.post('/cus/customer/addSign', data).then(res => {
        // this.Message.success('提交成功，客服不就会进行回访')
        if (res.data.code === 200) {
          this.$message({
            message: '提交成功，客服会对您进行回访',
            type: 'success',
            offset: 50
          });
          this.formData.cusEmail = ''
          this.formData.cusPhone = ''
          this.formData.cusWechat = ''
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 50
          });
        }

      })
    },
    goDetail() {
      window.open('https://baijiahao.baidu.com/s?id=1737492300364155678&wfr=spider&for=pc')
    },
    /**
     * @description: 合作流程划入
     * @author: 书童
     */
    processover(num) {
      this.processIndex = num
    },
    /**
     * @description: 合作流程划出
     * @author: 书童
     */
    processleave() {
      this.processIndex = null
    },
    /**
     * @description: 合作共赢模块划出
     * @author: 书童
     */
    coopleave() {
      this.coopIndex = 0
    },
    /**
     * @description: 合作共赢模块划入
     * @author: 书童
     */
    coopenter(index) {
      this.coopIndex = index
    },
    /**
     * @description: 页面滚动到顶部
     * @author: 书童
     */
    goBottom() {
      let top = this.$refs.box.offsetHeight, scrollTop = document.documentElement.scrollTop, clientHeight = document.documentElement.clientHeight
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = scrollTop += 50
        if (top <= (scrollTop + clientHeight)) {
          clearInterval(timeTop)
        }
      }, 10)
    },
  },
  mounted() {
    if (this.$public.isMobile()) {
      window.location.href = 'http://hmmwuliu.net/common/ws-m/business.html'
    }
  }
}
</script>

<style scoped lang="scss">
.title{
  font-size: 30px;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  text-align: center;
  color: #FFFFFF;
  line-height: 42px;
  margin-top: 70px;
}
.title_border{
  width: 40px;
  height: 2px;
  background: #f39801;
  margin: 6px auto 0;
}
.piaoju{
  overflow: hidden;
  height: 509px;
  width: 100%;
  .container1{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 509px;
    width: 1200px;
    padding: 50px 0 48px;
    box-sizing: border-box;
    margin: 0 auto;
    .piaoju_left{
      width: 665px;
      height: 411px;
      &>img{
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .piaoju_right{
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 500px;
      .piaoju_right_title{
        line-height: 42px;
        font-size: 30px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: LEFT;
        color: #000000;
      }
      .piaoju_right_border{
        width: 40px;
        height: 2px;
        background: #f39801;
        margin-top: 6px;
      }
      p{
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: LEFT;
        color: #333333;
        line-height: 22px;
        margin-top: 50px;
        margin-bottom: 60px;
      }
      .piaoju_right_btn{
        width: 145px;
        height: 41px;
        line-height: 41px;
        border: 1px solid #4e9bff;
        box-sizing: border-box;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: center;
        color: #4e9bff;
        cursor: pointer;
      }
      .piaoju_right_btn:hover{
        background-color: #4e9bff;
        color: #FFFFFF;
      }
    }
  }

}
.numberData{
  overflow: hidden;
  height: 364px;
  width: 100%;
  background: url('https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/bg/numberdata.png') no-repeat;
  background-size: 100% 100%;
  .box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .box_item{
      margin-top: 50px;
      .top{
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Bold;
        font-weight: 700;
        color: #ffffff;
        span{
          font-size: 50px;
        }
      }
      .center{
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        line-height: 28px;
        margin-top: 10px;
      }
      .bot{
        width: 100%;
        height: 14px;
        border: 2px solid rgba(255,255,255,0.10);
        border-top: none;
      }
    }
  }
}
.cooperation{
  height: 700px;
  .cooperationBox{
    display: flex;
    justify-content: flex-start;
    height: 470px;
    margin-top: 50px;
    .coop_item{
      height: 100%;
      width: 344px;
      padding-left: 20px;
      padding-right: 20px;
      padding-top: 52px;
      border-top: 2px solid #E0E0E0;
      box-sizing: border-box;
      transition: width 0.6s;
      -moz-transition: width 0.6s; /* Firefox 4 */
      -webkit-transition: width 0.6s; /* Safari 和 Chrome */
      -o-transition: width 0.6s; /* Opera */
      &>img{
        width: 304px;
        height: 242px;
      }
      .coop_item_title{
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
        height: 22px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: left;
        color: #333333;
        line-height: 22px;
        margin-top: 20px;
        margin-bottom: 10px;
      }
      .coop_item_content{
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: LEFT;
        color: #666666;
        line-height: 20px;
      }
    }
    .coop_item1{
      position: relative;
      height: 100%;
      width: 512px;
      padding-top: 52px;
      border-top: 2px solid #4E9BFF;
      box-sizing: border-box;
      transition: width 0.6s;
      -moz-transition: width 0.6s; /* Firefox 4 */
      -webkit-transition: width 0.6s; /* Safari 和 Chrome */
      -o-transition: width 0.6s; /* Opera */
      .pos{
        position: absolute;
        left: 0;
        right: 0;
        top: -8px;
        margin: auto;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: #ffffff;
        border: 3px solid #4e9bff;
        box-sizing: border-box;
        z-index: 2;
      }
      &>img{
        position: absolute;
        left: 0;
        top: 50px;
        width: 100%;
        height: 408px;
        z-index: -1;
      }
      .coop_item_box{
        overflow: hidden;
        position: absolute;
        left: 0;
        top: 50px;
        z-index: 1;
        width: 100%;
        height: 408px;
        background-color: rgba(51,51,51,0.50);
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        transition: all 0.4s;
        .coop_item_title{
          font-size: 18px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: LEFT;
          color: #ffffff;
          line-height: 25px;
          padding: 0 30px;
          box-sizing: border-box;

        }
        .coop_item_content{
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: LEFT;
          color: #ffffff;
          line-height: 20px;
          padding: 0 40px;
          box-sizing: border-box;
          margin-bottom: 40px;
          margin-top: 20px;
        }
      }

    }
  }
}
#process{
  overflow: hidden;
  width: 100%;
  height: 644px;
  background: url('https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/bg/process_bg.png') no-repeat;
  background-size: 100% 100%;
  .process_box{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    height: 341px;
    //background-color: red;
    margin-top: 50px;
    .process_box_item{
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 236px;
      height: 286px;
      background: linear-gradient(180deg,#dcebff, #ffffff 100%);
      border-radius: 40px;
      margin-right: 84px;
      .pos_box{
        position: absolute;
        left: 0;
        right: 0;
        bottom: -99px;
        margin: auto;
        height: 99px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .pos_line{
          display: block;
          height: 81px;
          width: 4px;
        }
        .pos_dotted{
          display: flex;
          justify-content: center;
          align-items: center;
          height: 18px;
          width: 18px;
          background: rgba(255,255,255,0.30);
          border-radius: 50%;
          &>div{
            height: 12px;
            width: 12px;
            background: #ffffff;
            border-radius: 50%;
          }
        }
      }
      .arrowPos{
        position: absolute;
        left: -52px;
        top: 110px;
        width: 20px;
        height: 27px;
      }
      .logo{
        display: block;
        width: 110px;
        height: 110px;
        margin-bottom: 28px;
      }
      .process_box_item_title{
        font-size: 18px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: LEFT;
        color: #333333;
        line-height: 25px;
        letter-spacing: 0.18px;
      }
      .jiantou{
        display: block;
        width: 166px;
        height: 6px;
        margin: 7px 0;
      }
    }
  }
  .posIcon{
    display: block;
    width: 100%;
    height: 97px;
  }
}
.submit{
  height: 730px;
  .submit_box{
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
    border-radius: 30px;
    box-shadow: 0px 0px 10px 2px rgba(0,0,0,0.05);
    .submit_box_left{
      width: 600px;
      height: 500px;
      &>img{
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .submit_box_right{
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 500px;
      padding: 0px 99px 0px 70px;
      box-sizing: border-box;
      .submit_box_right_title{
        font-size: 16px;
        font-family: Roboto, Roboto-Regular;
        font-weight: 400;
        text-align: LEFT;
        color: rgba(0,0,0,0.85);
        line-height: 22px;
        margin-bottom: 8px;
      }
      input{
        width: 100%;
        height: 50px;
        padding: 0 12px;
        background: #ffffff;
        border: 1px solid #d9d9d9;
        border-radius: 2px;
        box-sizing: border-box;
        margin-bottom: 30px;
      }
      .btn{
        width: 143px;
        height: 54px;
        line-height: 54px;
        text-align: center;
        font-size: 18px;
        font-family: Roboto, Roboto-Medium;
        font-weight: 500;
        color: #ffffff;
        background: #4e9bff;
        align-self: flex-end;
        cursor: pointer;
      }
    }
  }
}




</style>